
export default {
  name: 'BulletItem',

  props: {
    heading: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    bulletColor: {
      type: String,
      required: true,
    },
  },
};
